/**
 * Which AWS Batch job definition an environment runs on.
 *
 * Its own module rather than living in conchUtils: that file carries a live
 * Apollo client, moment and lodash, and this is a pure switch over a string —
 * anything needing only the mapping should not pull the rest in.
 */
export const jobDefinition = (
  environment: SensoryLinkEnvironment,
): conch.JobDefinition => {
  switch (environment) {
    case 'production_azure':
    case 'production':
      return 'gg-report-main';
    case 'staging':
      return 'gg-report-staging';
    case 'development_azure':
    case 'development':
      return 'gg-report-dev';
    case 'pre4azure':
      return 'gg-report-staging';
    default:
      return 'gg-report-main';
  }
};
